import { type AccommodationConfig, PALETTE_SIZE } from "@poi-planner/shared";
import {
  accommodationPalettes,
  defaultAccommodationPalette,
  type AccommodationPaletteEntry,
} from "../theme/colors";

export type PaletteEntry = AccommodationPaletteEntry;

/**
 * Returns the numeric palette index from accommodation config.
 * Returns -1 if no config provided.
 */
export function getAccommodationColorIndex(
  config: AccommodationConfig | undefined,
): number {
  if (!config) return -1;
  const color = config.color;
  if (color >= 0 && color < PALETTE_SIZE) return color;
  return 0;
}

/**
 * Returns the palette entry for an accommodation.
 */
export function getAccommodationPalette(
  config: AccommodationConfig | undefined,
): PaletteEntry {
  const index = getAccommodationColorIndex(config);
  if (index === -1) return defaultAccommodationPalette;
  return accommodationPalettes[index];
}
